import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { selectWorks } from '../../../Api/selectors';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { completeVehicleTransport, deleteVehicleProperty } from '../../../Vehicles/actions';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { refreshBoards } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { TransportAssignableOptions, TransportAssignableSortMap } from './Transport_1_nl_in';
import {REQUEST_COMPANIES_PROPERTY} from "../../../Companies/constants";
import {selectCompanyProperty} from "../../../Companies/selectors";
import {selectAddress} from "../../../Address/selectors";
import {REQUEST_ADDRESSES_BY_IDS} from "../../../Address/constants";

const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }

  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  loading: false,
  confirmReset: false,
};

/* eslint-disable react/prefer-stateless-function */
class Transport_plan_extern_outgoing_euComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_plan_extern_outgoing_eu.modal.title')}
      >
        {this.renderBody()}
      </Modal>
    );
  }

  renderBody() {
    if (this.props.work || this.state.loading)
      return (
        <HBox center>
          <Loader small />
        </HBox>
      );
    return (
      <>
        <HBox center vCenter>
          {this.state.confirmReset ? (
            <VBox center>
              <div>{this.lbl('reset')}?</div>
              <HBox>
                <Button
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.resetTransport(() => {
                      this.reset();
                    });
                  }}
                >
                  {this.lbl('confirm')}
                </Button>
                <Button onClick={this.setStateFn({ confirmReset: false })}>{this.lbl('cancel')}</Button>
              </HBox>
            </VBox>
          ) : (
            <Button onClick={this.setStateFn({ confirmReset: true })}>
              <EditSquare />
              {this.lbl('reset')}
            </Button>
          )}
        </HBox>
        <ModalControls>
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              <Button onClick={() => this.props.done(this.reset.bind(this))}>{this.lbl('complete')}</Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    return (
      <Cell>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <div className="regplate">
              <span style={{ opacity: 0.4 }}>({vehicle.id})</span>
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>


            </div>

            <HBox vCenter right>
              <VehicleStatusLabel>out</VehicleStatusLabel>&nbsp;
              <VehicleStatusLabel status={vehicle.status}>
                {TransportAssignableOptions.find(
                  dto => dto.value == this.vehicle.transport_outgoing_assigned_to,
                )?.label?.replace(/\_/g, ' ')}{' '}
                {this.vehicle.transport_assigned_to}
              </VehicleStatusLabel>
            </HBox>
          </HBox>
          <div className="address">{vehicle.vin || ''}</div>

          <div className="address">
            {this.props.fromCompanyName && (
              <CompanyLabelById fetchName company_id={vehicle.transport_outgoing_from_company_id} />
            )}
            {this.props.fromAddress && (
              <AddressFields inlineshort addressId={vehicle.transport_outgoing_from_address_id} />
            )}
          </div>
          <div className="address">
            {this.props.toCompanyName && (
              <CompanyLabelById fetchName company_id={vehicle.transport_outgoing_to_company_id} />
            )}
            {' '}
            {this.props.toAddress && (
              <AddressFields inlineshort addressId={vehicle.transport_outgoing_to_address_id} />
            )}
          </div>
          <hr />
          {vehicle.brand_name} {vehicle.model_name}
        </Container>
        {this.renderApprove()}
        <HBox style={{fontSize:"12px"}} onClick={this.tofn(`/vehicles/${vehicle.id}`)} >{vehicle.id} </HBox>
      </Cell>
    );
  }
}

Transport_plan_extern_outgoing_euComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    fromCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_outgoing_from_company_id, 'name'),
    toCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_outgoing_to_company_id, 'name'),
    fromAddress: selectAddress(ownProps.cell.vehicle.transport_outgoing_from_address_id),
    toAddress: selectAddress(ownProps.cell.vehicle.transport_outgoing_to_address_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    resetTransport(callback) {
      let id = ownProps.cell.vehicle.id;
      dispatch(
        deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_outgoing_assigned_to', () => {
          dispatch(
            deleteVehicleProperty(ownProps.cell.vehicle.id, 'transport_outgoing_initiated', () => {
              dispatch(refreshBoards());
              callback();
            }),
          );
        }),
      );
    },
    done(callback) {
      let id = ownProps.cell.vehicle.id;
      const action_name = ownProps.action.functionName;
      dispatch(
        completeVehicleTransport(id, true, false, action_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Transport_plan_extern_outgoing_eu = compose(
  withConnect,
  withRouter,
)(Transport_plan_extern_outgoing_euComp);
